<div *ngIf="deliveryOrderDetails" class="tab-section">
	<div class="tab-section-block mb-2">
		<h4 class="section-title">Order Processing</h4>
		<div class="details-grid">
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Time Requested</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.OrderDateTime | formatDate:'ddd., MMMM D, YYYY, HH:mm' }}</div>
			</div>
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Time Accepted</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.OrderAccepted | formatDate:'ddd., MMMM D, YYYY, HH:mm' }}</div>
			</div>
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Time Arrival on Pick up Point</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.ArrivedToPickupAt | formatDate:'ddd., MMMM D, YYYY, HH:mm' }}</div>
			</div>
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Time of Pick Up</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.PickupTime | formatDate:'ddd., MMMM D, YYYY, HH:mm' }}</div>
			</div>
			<div class="flex align-items-center py-2">
				<div class="field-name w-6">Time of Drop Off</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.DroppedOffTime | formatDate:'ddd., MMMM D, YYYY, HH:mm' }}</div>
			</div>
		</div>
	</div>
</div>
